// marketplaceService.js — R42 : client du marketplace on-chain (via miroir serveur)
import api from './api';

/**
 * Listings actifs (escrow on-chain, indexés par le serveur).
 * @returns {Promise<{ success:boolean, listings:Array }> } chaque listing :
 *   { listing, nftMint, cardId, seller, priceMicro, state, listedAt, card }
 *   card = données carte enrichies (nom, élément, rareté, imageUrl) ou null.
 */
export const getListings = async () => {
  try {
    const response = await api.get('/marketplace/listings');
    return response.data;
  } catch (error) {
    console.error('[MARKETPLACE] Erreur listings :', error.message);
    return { success: false, listings: [], message: error.message };
  }
};

/** Prix affichable : micro-ORI → ORI (6 décimales). */
export const formatOri = (priceMicro) => {
  const ori = (priceMicro || 0) / 1e6;
  return ori.toLocaleString('fr-FR', { maximumFractionDigits: 2 }) + ' ORI';
};

// ─── R44 : transactions on-chain (list / buy / cancel) ───

/** Config on-chain du marketplace (ori mint, reserve, burn…). */
export const getOnchainConfig = async () => {
  try { return (await api.get('/marketplace/onchain/config')).data; }
  catch (e) { return { success: false, message: e.message }; }
};

/** NFT détenus par une adresse (pour « Mettre en vente »). */
export const getWalletNfts = async (address) => {
  try { return (await api.get(`/marketplace/wallet/nfts?address=${encodeURIComponent(address)}`)).data; }
  catch (e) { return { success: false, nfts: [], message: e.message }; }
};

/** Construit la tx de mise en vente (server-side). */
export const buildListTx = async (nftMint, priceMicro, seller, localSecret) => {
  try { return (await api.post('/marketplace/tx/list', { nftMint, priceMicro, seller, localSecret })).data; }
  catch (e) { return { success: false, message: e.response?.data?.message || e.message }; }
};

/** Construit la tx d'achat (server-side). */
export const buildBuyTx = async (seller, nftMint, buyer, localSecret) => {
  try { return (await api.post('/marketplace/tx/buy', { seller, nftMint, buyer, localSecret })).data; }
  catch (e) { return { success: false, message: e.response?.data?.message || e.message }; }
};

/** Construit la tx d'annulation (server-side). */
export const buildCancelTx = async (nftMint, seller, localSecret) => {
  try { return (await api.post('/marketplace/tx/cancel', { nftMint, seller, localSecret })).data; }
  catch (e) { return { success: false, message: e.response?.data?.message || e.message }; }
};
